import React from 'react'
import FirstLoadController from '../../components/FirstLoadController'
import SalesAnalysis from './SalesAnalysis'

export default function (props: Props) {
  return (
    <FirstLoadController active={props.active}>
      <SalesAnalysis {...props} />
    </FirstLoadController>
  )
}
